import { TakerOrMaker, TradeV2 } from "@cede/types";
import { randomId } from "../random";
import Decimal from "decimal.js";

export class TradeV2Factory {
  private trades: TradeV2[] = [];

  create({ amount, price }: { amount?: Decimal.Value; price?: Decimal.Value } = {}) {
    this.trades.push({
      id: randomId(),
      amount: new Decimal(amount ?? 1),
      price: new Decimal(price ?? 1),
      timestamp: new Date().getTime(),
      pairSymbol: "",
      side: "buy",
      takerOrMaker: TakerOrMaker.MAKER,
      fee: {
        amount: new Decimal(0),
        tokenSymbol: "",
      },
    });
    return this;
  }

  getAll(): TradeV2[] {
    return this.trades;
  }
}
